<template>
  <div class="moviecouponApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="back">
      <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i>返回</span>
      <div class="mymcorder" @click="$router.push('couponorder')">我的订单 {{orderTotal}} <i class="el-icon-arrow-right"></i></div>
    </div>
    <div style="height:15px"></div>
    <ul>
      <li v-for="(item,i) in coupon" @click="toPush(item.id,'coupondetail?bak=1')">
        <div class="cate">优惠券可用<font style="font-size:14px;padding-left:5px">({{item.num}}张)</font></div>
        <div class="con">
          <h2>{{item.title}}</h2>
          <p>有效期至 {{item.endTime}}</p>
        </div>
        <div class="price">
          <h3><font>￥</font>-{{item.price}}</h3>
          <p>满{{item.use}}可用</p>
        </div>
        <div class="payPrice">
          <span>￥{{item.rates}}</span>
          <a :style="item.total - item.useTotal <= 0 ? 'background:#ccc' :''">{{item.total - item.useTotal > 0 ? '立即购买' :'售罄'}}</a>
        </div>
      </li>
    </ul>
    <div class="none" v-if="coupon.length <= 0">
      <img src="~assets/images/none.png" />
      <p>空空如也~</p>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        coupon:[],
        dialogFormVisible:false,
        orderTotal:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.listCoupon()
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        window.location.href='http://user.4008005216.com/main/'+url+'&id='+index
        /*this.$router.push({
          path:url,
          query:{
            id:index
          }
        })*/
      },

      listCoupon:function(){
        var that = this;
        that.fullscreenLoading = true
        $.ajax({
          type:'post',
          data:{
            user_id:that.userData.id
          },
          url:that.$host+'home/movies/coupon',
          dataType:'json',
          success:function(data){
            that.coupon = data.data.rs;
            that.orderTotal = data.data.total
            that.fullscreenLoading = false;
          }
        })
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }

  .el-dialog{
    width:85% !important;
  }
  .moviecouponApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  
  .moviecouponApp .back{
    width:94%;
    margin:0 auto;
    padding-top:15px;
    color:#666;
    font-size:14px
  }
  .moviecouponApp .back i{
    font-size:14px;
    color:#666
  }
  .moviecouponApp .back .mymcorder{
    float:right;
    color:#3F9DEC
  }
  .moviecouponApp .back .mymcorder i{
    color:#3F9DEC
  }
  .moviecouponApp ul{
    width:94%;
    display:block;
    margin:0 auto;
  }
  .moviecouponApp ul li{
    width:100%;
    display:block;
    background:#fff;
    border-radius:10px;
    position: relative;
    margin-bottom:15px;
    padding-bottom:15px
  }
  .moviecouponApp ul li .cate{
    position: absolute;
    top:0;
    left:0;
    background:rgba(255,30,0,0.7);
    color:#fff;
    border-radius:10px 0 10px 0;
    font-size:14px;
    padding:6px;
  }

  .moviecouponApp ul li .con{
    width:92%;
    margin:0 auto;
    padding:40px 0 0px 0;
  }
  .moviecouponApp ul li .con h2{
    font-size:18px;
    font-weight:normal;
    width:72%;
  }
  .moviecouponApp ul li .con p{
    font-size:15px;
    color:#666;
    padding-top:5px
  }
  .moviecouponApp ul li .price{
    position: absolute;
    top:40px;
    right:4%;
  }
  .moviecouponApp ul li .price h3{
    font-size:20px;
    color:#666;
    text-align:center;
  }
  .moviecouponApp ul li .price h3 font{
    font-size:15px;
    font-weight:normal;
    color:#666;
  }
  .moviecouponApp ul li .price p{
    color:rgb(255,30,0);
    font-size:13px;
    text-align:center;
    padding-top:2px;
    color:#999;
  }
  .moviecouponApp ul li .payPrice{
    width:92%;
    margin:15px auto 0 auto;
    height:30px;
  }
  .moviecouponApp ul li .payPrice span{
    color:#f00;
    font-size:16px;
    font-weight:bold;
    line-height:30px;
  }
  .moviecouponApp ul li .payPrice a{
    float:right;
    font-size:14px;
    color:#fff;
    height:30px;
    background: linear-gradient(90deg, #FE506A, #FE5CA3);
    line-height:30px;
    padding:0 10px;
    border-radius: 30px;
  }

  .moviecouponApp .none{
    text-align:center;
    padding-top:120px;
  }
  .moviecouponApp .none img{
    display:block;
    margin:0px auto;
    width:100px;
  }
  .moviecouponApp .none p{
    color:#999;
    font-size:15px;
    padding-top:5px;
    letter-spacing:2px;
  }

</style>